// extracted by mini-css-extract-plugin
module.exports = {"bodyMainText":"logoConfiguration_bodyMainText__39Xrp","dividerLine":"logoConfiguration_dividerLine__18mwv","navigateBtnCol":"logoConfiguration_navigateBtnCol__3R20T"};